module.exports = __webpack_public_path__ + "img/tags_video.51ec7722.png";